import { 
  DollarSign, Euro, PoundSterling, 
  SwissFranc, IndianRupee
} from "lucide-react";

export type CurrencyCode = 
  | 'USD' | 'EUR' | 'JPY' | 'GBP' | 'CNY' | 'AUD' | 'CAD' | 'CHF' | 'HKD' | 'SGD'
  | 'SEK' | 'KRW' | 'NOK' | 'NZD' | 'INR' | 'MXN' | 'TWD' | 'ZAR' | 'BRL' | 'DKK'
  | 'PLN' | 'THB' | 'ILS' | 'IDR' | 'CZK' | 'AED' | 'TRY' | 'HUF' | 'CLP' | 'SAR'
  | 'PHP' | 'MYR' | 'COP' | 'RUB' | 'RON' | 'PEN';

interface CurrencyInfo {
  symbol: string;
  name: string;
  icon?: typeof DollarSign;
  code: CurrencyCode;
}

export const currencyConfig: Record<CurrencyCode, CurrencyInfo> = {
  USD: { symbol: '$', name: 'U.S. Dollar', code: 'USD', icon: DollarSign },
  EUR: { symbol: '€', name: 'Euro', code: 'EUR', icon: Euro },
  GBP: { symbol: '£', name: 'British Pound', code: 'GBP', icon: PoundSterling },
  CHF: { symbol: 'Fr', name: 'Swiss Franc', code: 'CHF', icon: SwissFranc },
  INR: { symbol: '₹', name: 'Indian Rupee', code: 'INR', icon: IndianRupee },
  JPY: { symbol: '¥', name: 'Japanese Yen', code: 'JPY' },
  CNY: { symbol: '¥', name: 'Chinese Yuan', code: 'CNY' },
  AUD: { symbol: 'A$', name: 'Australian Dollar', code: 'AUD' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar', code: 'CAD' },
  HKD: { symbol: 'HK$', name: 'Hong Kong Dollar', code: 'HKD' },
  SGD: { symbol: 'S$', name: 'Singapore Dollar', code: 'SGD' },
  SEK: { symbol: 'kr', name: 'Swedish Krona', code: 'SEK' },
  KRW: { symbol: '₩', name: 'South Korean Won', code: 'KRW' },
  NOK: { symbol: 'kr', name: 'Norwegian Krone', code: 'NOK' },
  NZD: { symbol: 'NZ$', name: 'New Zealand Dollar', code: 'NZD' },
  MXN: { symbol: '$', name: 'Mexican Peso', code: 'MXN' },
  TWD: { symbol: 'NT$', name: 'New Taiwan Dollar', code: 'TWD' },
  ZAR: { symbol: 'R', name: 'South African Rand', code: 'ZAR' },
  BRL: { symbol: 'R$', name: 'Brazilian Real', code: 'BRL' },
  DKK: { symbol: 'kr', name: 'Danish Krone', code: 'DKK' },
  PLN: { symbol: 'zł', name: 'Polish Złoty', code: 'PLN' },
  THB: { symbol: '฿', name: 'Thai Baht', code: 'THB' },
  ILS: { symbol: '₪', name: 'Israeli New Shekel', code: 'ILS' },
  IDR: { symbol: 'Rp', name: 'Indonesian Rupiah', code: 'IDR' },
  CZK: { symbol: 'Kč', name: 'Czech Koruna', code: 'CZK' },
  AED: { symbol: 'د.إ', name: 'UAE Dirham', code: 'AED' },
  TRY: { symbol: '₺', name: 'Turkish Lira', code: 'TRY' },
  HUF: { symbol: 'Ft', name: 'Hungarian Forint', code: 'HUF' },
  CLP: { symbol: '$', name: 'Chilean Peso', code: 'CLP' },
  SAR: { symbol: '﷼', name: 'Saudi Riyal', code: 'SAR' },
  PHP: { symbol: '₱', name: 'Philippine Peso', code: 'PHP' },
  MYR: { symbol: 'RM', name: 'Malaysian Ringgit', code: 'MYR' },
  COP: { symbol: '$', name: 'Colombian Peso', code: 'COP' },
  RUB: { symbol: '₽', name: 'Russian Ruble', code: 'RUB' },
  RON: { symbol: 'lei', name: 'Romanian Leu', code: 'RON' },
  PEN: { symbol: 'S/', name: 'Peruvian Sol', code: 'PEN' }
};

export const formatSalary = (amount: number | null, currency: CurrencyCode): string => {
  if (amount === null) return '-';
  
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0
  }).format(amount);
};
